const waitForGtagThen = (callback: Function, maxTries: number | null = null) => {
	let tries = 0;
	const interval = setInterval(() => {
		tries++;
		//@ts-ignore
		if (typeof gtag === 'function') {
			clearInterval(interval);
			callback();
		}
		if (maxTries && tries >= maxTries) {
			clearInterval(interval);
		}
	}, 200);
}

// export const trackTagManagerEvent = (eventName: string, obj: any) => {
//   //@ts-ignore
//   if (typeof gtag === 'function') {
//     //@ts-ignore
//     gtag('event', eventName, obj);
//   }
// }


export interface HomeAddress {
	street: string,
	postal_code: string,
	city: string,
	country: string

}

declare const window: Window & { dataLayer?: Record<string, unknown>[] };

function getDataLayer() {
	if (!("dataLayer" in window)) {
		window.dataLayer = window.dataLayer || [];
	}
	return <Record<string, unknown>[]>window.dataLayer;
}

export interface ViewSearchResultsItem {
	propertyId: string,
	rentalCompany: string,
	country: string,
	price: number,
	nights: number
}

export interface GtmHotelData {
	city?: string
	region?: string
	country?: string
	checkin_date?: string
	checkout_date?: string
	num_adults?: number
	num_children?: number
}

function mapItem(item: ViewSearchResultsItem) {
	return ({
		item_id: item.propertyId, // houseID
		item_name: item.propertyId, // houseID
		affiliation: window.location.hostname, // domain
		item_brand: item.rentalCompany, // rental company
		item_category: item.country, // country
		price: item.nights == 0 ? 0 : round(item.price / item.nights),
		quantity: item.nights == 0 ? 0 : item.nights
	})
}

const round = (value: any, decimals = 2) => {
	return Number(Math.round(parseFloat(value + 'e' + decimals)) + 'e-' + decimals) || 0;
}

function resetHotalData(dataLayer: Record<string, unknown>[]) {
	dataLayer.push({ 
		hotel_data: {
			num_adults: "",
			num_children: "",
			checkin_date: "",
			checkout_date: "",
			country: "",
			region: "",
			city: ""
		}
	});
}

export function viewSearchResults(search_term: string, currency: string, items: ViewSearchResultsItem[]) {
	const dataLayer = getDataLayer();
	dataLayer.push({ ecommerce: null });
	resetHotalData(dataLayer);
	dataLayer.push({
		event: "view_search_results",
		search_term: search_term, // areaName
		ecommerce: {
			currency: currency,
			items: items.map(mapItem)
		}
	});
}

export function viewItemList(currency: string, items: ViewSearchResultsItem[], hotelData: GtmHotelData) {
	const dataLayer = getDataLayer();
	dataLayer.push({ ecommerce: null });
	resetHotalData(dataLayer);
	dataLayer.push({
		event: "view_item_list",
		ecommerce: {
			currency: currency,
			items: items.map(mapItem)
		},
		hotel_data: hotelData
	});
}

export function viewItem(currency: string, value: number, item: ViewSearchResultsItem, hotelData: GtmHotelData) {
	const dataLayer = getDataLayer();
	dataLayer.push({ ecommerce: null });
	resetHotalData(dataLayer);
	dataLayer.push({
		event: "view_item",
		ecommerce: {
			currency: currency,
			value: round(value),
			items: [mapItem(item)]
		},
		hotel_data: hotelData
	});
}

export function addToWishlist(currency: string, value: number, item: ViewSearchResultsItem) {
	const dataLayer = getDataLayer();
	dataLayer.push({ ecommerce: null });
	resetHotalData(dataLayer);
	dataLayer.push({
		event: "add_to_wishlist",
		ecommerce: {
			currency: currency,
			value: round(value),
			items: [mapItem(item)]
		}
	});
}

export function addToCart(currency: string, value: number, item: ViewSearchResultsItem) {
	const dataLayer = getDataLayer();
	dataLayer.push({ ecommerce: null });
	resetHotalData(dataLayer);
	dataLayer.push({
		event: "add_to_cart",
		ecommerce: {
			currency: currency,
			value: round(value),
			items: [mapItem(item)]
		}
	});
}

export function beginCheckout(currency: string, value: number, item: ViewSearchResultsItem, hotelData: GtmHotelData) {
	const dataLayer = getDataLayer();
	dataLayer.push({ ecommerce: null });
	resetHotalData(dataLayer);
	dataLayer.push({
		event: "begin_checkout",
		ecommerce: {
			currency: currency,
			value: round(value),
			items: [mapItem(item)]
		},
		hotel_data: hotelData
	});
}

export interface UserData {
	email: string,
	phone: string,
	first_name: string,
	surname: string,
	street: string,
	city: string,
	postcode: string,
	country: string
}

export function purchase(bookingId: string, currency: string, value: number, item: ViewSearchResultsItem, userData: UserData, hotelData: GtmHotelData) {
	const dataLayer = getDataLayer();
	dataLayer.push({ ecommerce: null });
	resetHotalData(dataLayer);
	dataLayer.push({
		event: "purchase",
		ecommerce: {
			transaction_id: bookingId,
			currency: currency,
			value: round(value), // profit excl vat
			tax: 0,
			shipping: 0,
			items: [mapItem(item)]
		},
		user_data: userData,
		hotel_data: hotelData
	});
}


export function bookMeeting(email: string, phone: string) {
	const dataLayer = getDataLayer();
	dataLayer.push({
		event: "book_meeting",
		user_data: {
			email: email,
			phone: phone
		}
	});
}

export function calculateRentalIncome(email: string, phone: string) {
	const dataLayer = getDataLayer();
	dataLayer.push({
		event: "calculate_rental_income",
		user_data: {
			email: email,
			phone: phone
		}
	});
}

export function createOwnerAccount(email: string, phone: string) {
	const dataLayer = getDataLayer();
	dataLayer.push({
		event: "create_owner_account",
		user_data: {
			email: email,
			phone: phone
		}
	});
}
